import { render, staticRenderFns } from "./Vision.vue?vue&type=template&id=8d240aa0&scoped=true"
import script from "./Vision.vue?vue&type=script&lang=js"
export * from "./Vision.vue?vue&type=script&lang=js"
import style0 from "./Vision.vue?vue&type=style&index=0&id=8d240aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d240aa0",
  null
  
)

export default component.exports